import { formatDate } from './dateUtils';

/** One selected expiry string matches row expiry (normalized dates or YYYYMMDD digits). */
export function expirySingleMatchesSelection(expiryRaw: unknown, selectedExpiry: string): boolean {
  if (selectedExpiry === 'all') return true;
  const normRow = formatDate(expiryRaw);
  const normSel = formatDate(selectedExpiry);
  if (normRow && normSel && normRow === normSel) return true;
  const d1 = String(expiryRaw ?? '').replace(/\D/g, '').slice(0, 8);
  const d2 = String(selectedExpiry ?? '').replace(/\D/g, '').slice(0, 8);
  return d1.length === 8 && d2.length === 8 && d1 === d2;
}

/** Row matches if any selected expiry matches (union for combined charts). */
export function expiryRowMatchesSelection(expiryRaw: unknown, selectedExpiries: string[]): boolean {
  if (!selectedExpiries?.length || selectedExpiries.includes('all')) return true;
  return selectedExpiries.some((sel) => expirySingleMatchesSelection(expiryRaw, sel));
}
